import React, { useState, useEffect, useMemo } from 'react'
import lodash from 'lodash'
import styled from 'styled-components'

import { FormRow, Col } from '../../../../../../../1stlog-ui/src/components/Bootstrap'
import { useField, FeedbackBadge } from '../../../../../../../1stlog-ui/src/components/Field'

const validate = (value) =>
  value
    ? i18n.t('error_exceeds_point_limit_long', 'Gefahrgüter überschreiten 1000 Punkte')
    : undefined

const Points = (props) => {
  const { hazmats } = props

  const {
    input: { value: isPointsInvalid, onChange: setIsPointsInvalid },
    meta
  } = useField('validation.isPointsInvalid', {
    raw: true,
    validate,
    subscribeAll: true
  })

  useEffect(() => {
    const hazmatPoints = lodash.sum(
      lodash.map(hazmats, (hazmat) => {
        const {
          count = 1,
          amount = 0,
          pointMultiplicator = 0,
          allowedFor1000PointTransport,
          limitedQuantityEnabled
        } = hazmat
        // FIXME: what to do with allowedFor1000PointTransport
        if (!allowedFor1000PointTransport) {
          return 0 // return -9999999999
        }

        if (!allowedFor1000PointTransport || limitedQuantityEnabled || pointMultiplicator === 0) {
          return 0
        }

        return amount * pointMultiplicator * count
      })
    )
    const newIsPointsInvalid = hazmatPoints > 1000
    if (!lodash.isEqual(isPointsInvalid, newIsPointsInvalid)) {
      setIsPointsInvalid(newIsPointsInvalid)
    }
  }, [hazmats])

  return (
    isPointsInvalid && (
      <FormRow>
        <Col>
          <FeedbackBadge meta={meta} />
        </Col>
      </FormRow>
    )
  )
}

export default Points
